import { trackFormSubmissionFlow } from '../../helpers';

export function trackFormServiceApiPayload(formData = {}) {
	if (!formData || !Object.keys(formData).length) {
		return;
	}

	const data = {};
	const excludedKeys = [
		'firstName',
		'lastName',
		'phone',
		'email',
		'address',
		'zip',
		'FN',
		'LN',
		'EM',
		'HP',
		'PC',
		'S1'
	];

	Object.entries(formData).forEach(([key, value]) => {
		if (!excludedKeys.includes(key)) {
			data[key] = value;
		}
	});

	trackFormSubmissionFlow({ formServiceApiPayload: JSON.stringify(data) });
}
